import React, { useEffect, useMemo, useState } from 'react';
import 'moment/locale/es';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';

import './justificarMinutaGrilla.scss';
import { JustificarMinutaGrillaHeader } from './JustificarMinutaGrillaHeader';
import { JustificarMinutaGrillaFilters } from './JustificarMinutaGrillaFilters';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { formatCurrency } from "../../../utils/mathUtils";
import { IconButton } from '@mui/material';

export const JustificarMinutaGrilla = ({ setChildrenAction }) => {

    const navigate = useNavigate();

    const [allowedWrite, setAllowedWrite] = useState(false);
    const [delegaciones, setDelegaciones] = useState([]);
    const [justificacionesGrilla, setJustificacionesGrilla] = useState([]);
    const [justificacionesGrillaLoading, setJustificacionesGrillaLoading] = useState(false);
    const [justificacionesSeleccionadas, setJustificacionesSeleccionadas] = useState([]);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [refetchGrilla, setRefetchGrilla] = useState(false);
    const [generateRunning, setGenerateRunning] = useState(false);
    const [periodoActivo, setPeriodoActivo] = useState(null);

    const { filters, handleChangeFilters } = usePersistFilters({
        idDelegacion: 0
    }, "justificarMinutaGrillaFilters");

    const location = useLocation();
    const rutasStorage = localStorage.getItem('navigationRoutes');

    useEffect(() => {
        if (rutasStorage) {
            const rutas = JSON.parse(rutasStorage);
            const rutaQueSirve = location.pathname;
            setAllowedWrite(rutas?.find(ruta => ruta.aplicaciones.find(app => app.url == rutaQueSirve)
            )?.aplicaciones?.find(app => app.url == rutaQueSirve).escritura);
        }
    }, [rutasStorage]);

    useEffect(() => {
        setChildrenAction(() => (
            <JustificarMinutaGrillaHeader
                allowedWrite={allowedWrite}
                justificacionesGrilla={justificacionesGrilla}
                justificacionesSeleccionadas={justificacionesSeleccionadas}
                filters={filters}
                handleChange={handleChangeFilters}
                setJustificacionesSeleccionadas={setJustificacionesSeleccionadas}
                setRefetchGrilla={setRefetchGrilla}
                setGenerateRunning={setGenerateRunning}
                periodoActivo={periodoActivo}
                setPeriodoActivo={setPeriodoActivo}
            />
        ));
    }, [
        setChildrenAction,
        filters,
        justificacionesGrilla,
        justificacionesSeleccionadas,
        allowedWrite
    ]);

    const handleClickAction = (row) => {
        navigate(location.pathname + '/detalle', {
            state: {
                allowedWrite: allowedWrite,
                dataRegistro: row,
                idDelegacion: filters?.idDelegacion,
                delegacion: delegaciones.filter(d => d.id == filters?.idDelegacion)[0]?.name
            }
        });
    }

    const disabledCheckbox = (row) => {
        return (!allowedWrite);
    }

    const handleSelectionModelChange = (ids) => {
        setRowSelectionModel(ids);
        if (ids.length > 0) {
            setJustificacionesSeleccionadas(justificacionesGrilla.filter((row, index) => {
                return ids.includes(index + 1);
            }));
        } else {
            setJustificacionesSeleccionadas([]);
        }
    }

    const initialColumns = [
        {
            headerName: '',
            field: 'action',
            noPadding: true,
            flex: 0.03,
            minWidth: 35,
            maxWidth: 35,
            sortable: false,
            align: 'center',
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (
                    <IconButton onClick={() => handleClickAction(row)}>
                        <VisibilityIcon sx={{ fontSize: '13pt' }} />
                    </IconButton>
                )
            }
        },
        {
            field: 'idPendiente',
            headerName: '#',
            flex: 0.13
        },
        {
            field: 'idEvaluacion',
            headerName: 'Contrato',
            flex: 0.14
        },
        {
            field: 'idPaciente',
            headerName: 'HC',
            flex: 0.13
        },
        {
            field: 'paciente',
            headerName: 'Paciente',
            flex: 0.35
        },
        {
            field: 'codClienteSAP',
            headerName: 'Cod. Cliente',
            flex: 0.19
        },
        {
            field: 'cliente',
            headerName: 'Cliente',
            flex: 0.35
        },
        {
            field: 'modulo',
            headerName: 'Plan',
            flex: 0.32
        },

        {
            field: 'cantidadConexion',
            headerName: 'Cnxs',
            description: 'Conexiones',
            flex: 0.11
        },
        {
            field: 'precioDiario',
            headerName: '$ Diario',
            flex: 0.19,
            align: 'right',
            headerAlign: 'right',
            valueGetter: (precioDiario) => {
                return formatCurrency(precioDiario);
            }
        },
        {
            field: 'precioSAP',
            headerName: '$ SAP',
            flex: 0.19,
            align: 'right',
            headerAlign: 'right',
            valueGetter: (precioSAP) => {
                return formatCurrency(precioSAP);
            }
        },
        {
            field: 'precioTotal',
            headerName: '$ Total',
            flex: 0.20,
            valueGetter: (precioTotal) => {
                return formatCurrency(precioTotal);
            }
        },
    ];

    const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [filters, allowedWrite]);

    return (
        <>
            <div>
                <JustificarMinutaGrillaFilters
                    delegaciones={delegaciones}
                    filters={filters}
                    handleChangeFilters={handleChangeFilters}
                    setJustificacionesGrilla={setJustificacionesGrilla}
                    setJustificacionesGrillaLoading={setJustificacionesGrillaLoading}
                    setDelegaciones={setDelegaciones}
                    refetchGrilla={refetchGrilla}
                    setRefetchGrilla={setRefetchGrilla}
                    generateRunning={generateRunning}
                />
                <br />
                <DataGridGenerico
                    columns={columns}
                    rows={justificacionesGrilla}
                    toolbar={false}
                    maxWidth={columns.reduce(
                        (total, column) => total + (column.width || 0),
                        0
                    )}
                    checkboxSelection={true}
                    isRowSelectable={(param) => !disabledCheckbox(param.row)}
                    onRowSelectionModelChange={handleSelectionModelChange}
                    rowSelectionModel={rowSelectionModel}
                    loading={justificacionesGrillaLoading}
                />
            </div>
            <Outlet />
        </>
    )
}